export const usePlan = () => {
  const config = useRuntimeConfig();
  const name = globalConfig()?.config?.owner_plan?.name;

  return {
    isBronze: name === 'BRONZE',
    isSilver: name === 'SILVER',
    isPlatinum: name === 'PLATINUM',
    isSpotsurfer: config?.public?.isMain
  }
};
